var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSortDescend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4259_9069",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4259_9069",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAABVElEQVR4nO3Zy07EMBBFQf/1LM2fN0KCDWgUAoHruKukbEdOH8V5zBgAAAAA8Fzd7Djr6t+7XHqgJUB+qOUKyA+2bEH3OM66+vculx5oCZAfarkC8oOtrlvQ7kqALAHCBAgTIEyAMAHCBAhbPkD6xar+eCACDAFcAcMWNGxB7gHDTXi4CXsKGh5Dh8fQRmr1F7HdlQBZAoQJECZAmABhAoQtH+Du3/uPrLaeLwQIEyBMgDABwgQIEyBMAHq/B+yuBMgSIEyAMAHCBAgTIGz5AHf/3n9k+fUKECZAmABhAoQJECZAmACc8gj8ifRxzHNL3dfD8HtFmOmT7Rxhpk+yc4SZPrnOEWb6pDpHmOmT6Rxh/veizy5w5wgzseDdAvw0Qmzb2THA2QjRPX/XAN+NEL/h7hzgKEJ8+B0CPIuwxPC7BPgcYZnhdwrw5uX9AAAAAIDxW69VJhjEtIZnmQAAAABJRU5ErkJggg=="
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSortDescend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/sort_descend.6799b71e192ed0089c77fad26d96a423.svg";